export function buildLotAltText(
  title?: string,
  artist_name?: string,
  artist_lifespan?: string,
  object_type?: string,
  year?: string
): string {
  const parts: string[] = [];

  if (artist_name) {
    parts.push(
      artist_lifespan ? `${artist_name} (${artist_lifespan})` : artist_name
    );
  }

  if (object_type) parts.push(object_type);
  if (title) parts.push(title);
  if (year) parts.push(year);

  return parts.join(", ").slice(0, 200);
}
